
import { Component, Prop, Vue } from 'vue-property-decorator';

import { NewsProvision } from '@/helpers/composables/useArticle';
import { LinkedTitleFragment } from '@/pages/graphql/queries/GetArticleByUrl.query';

import { getBackdropClips } from '@/helpers/title-helper';
import { getArticleBackdrop } from '@/helpers/editorial-helper';
import { clickPlayOnTrailer } from '@/pages/editorial/tracking';

import AdUnit from '@/components/AdUnit.vue';
import BuyBox from '@/components/buybox/BuyBox.vue';
import TitleCredits from '@/components/details/TitleCredits.vue';
import TitleInfo from '@/components/details/TitleInfo.vue';
const ProvideStreamingChartData = () => import('@/components/streaming-charts/ProvideStreamingChartData.vue');
import TitleDetailStreamingChart from '@/components/details/streaming-chart/TitleDetailStreamingChart.vue';
import BackdropTrailer from '@/components/details/backdrops/BackdropTrailer.vue';
import GuideList from '@/components/editorial/GuideList.vue';

import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';

@Component({
	name: 'NewsArticle',
	components: {
		AdUnit,
		BackdropTrailer,
		BuyBox,
		ProvideStreamingChartData,
		TitleCredits,
		TitleInfo,
		TitleDetailStreamingChart,
		GuideList,
	},
	metaInfo() {
		return this.head;
	},
})
export default class NewsArticle extends Vue {
	@Prop({ required: true }) article: NewsProvision['article'];
	@Prop({ required: true }) mainObject: NewsProvision['mainObject'];

	activeClipId: string | null = null;
	setActiveClip(activeClipId: string) {
		this.activeClipId = activeClipId;
		this.trackClickPlayOnTrailer();
	}

	get titleClips() {
		return getBackdropClips(this.mainObject as any);
	}

	get trailerThumbnail() {
		const title = this.mainObject;

		const pathExtension = title.content.fullPath
			? `/${title.content.fullPath.substring(title.content.fullPath.lastIndexOf('/') + 1)}`
			: '';

		return title.content.backdrops.map(backdrop => backdrop.backdropUrl + pathExtension)[0] ?? '';
	}

	get head() {
		const backdropUrl = getArticleBackdrop(this.mainObject, this.$store.state, 'backdrop');
		return {
			meta: [
				{ vmid: 'og:image', property: 'og:image', content: backdropUrl },
				{ vmid: 'og:image:width', property: 'og:image:width', content: '1920' },
				{ vmid: 'og:image:height', property: 'og:image:height', content: '900' },
			],
		};
	}

	isInWatchList(title: LinkedTitleFragment) {
		if (title.__typename === 'Season') return false;

		return !!title.watchlistEntryV2?.createdAt;
	}

	/* TRACKING */
	trackClickPlayOnTrailer() {
		clickPlayOnTrailer({
			category: 'youtube_playing',
			action: this.mainObject.objectType,
			label: 'backdrop',
			contexts: [new SnowplowTitleContextGraphql(this.mainObject.objectId, this.mainObject.objectType)],
		});
	}

	/* TRACKING */
	trackClick(e: Event) {
		const target = e.target as HTMLElement;
		if (target.nodeName !== 'A') return;

		this.$emit('content-clicked', e);
	}
}
